import React from 'react';

import { QueryContainer } from '@components/QueryContainer';
import { DeliveryInstructionEditDisplay } from '@components/utilities/Bookings/DeliveryInstructionEditDisplay';
import { useDeliveryInstruction } from '@hooks/queries/dashboard/useDeliveryInstruction';
import { useUser } from '@hooks/queries/useUser';
import { useOpenInVscode } from '@hooks/useOpenInVscode';
import { useSearch } from '@hooks/useSearch';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

const searchType = t.type({
  d2dNo: h.string(),
});

export const DeliveryInstruction: React.FC = () => {
  const {
    search: { d2dNo },
  } = useSearch(searchType);

  const deliveryInstruction = useDeliveryInstruction(d2dNo);
  const data = deliveryInstruction.data!;
  const user = useUser();

  if (import.meta.env.DEV) useOpenInVscode();

  return (
    <QueryContainer queries={[deliveryInstruction]}>
      {() => (
        <DeliveryInstructionEditDisplay
          user={user.data!}
          d2dNo={d2dNo}
          deliveryInstruction={data}
          type="admin"
          onGoBack={() => {}}
        />
      )}
    </QueryContainer>
  );
};
